import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { setCurrentStep, setSelectedDealer } from '../store/quoteSlice';
import { DEALER_AUTO_SELECTED_ORDER, stepAfterSkippedDealer } from '../services/quoteStepOrder';
import type { Dealer } from '@/features/dealers/types/dealers.types';

/** Picks the user's only visible dealer and moves the journey off the skipped dealer step. */
export const useAutoSelectSingleDealer = (autoDealer: Dealer | null, defer: boolean): void => {
    const dispatch = useAppDispatch();
    const hasSelectedDealer = useAppSelector((s) => s.quote.selectedDealer !== null);
    const currentStep = useAppSelector((s) => s.quote.currentStep);
    const hasProgress = useAppSelector(
        (s) => !!s.quote.quoteId || s.quote.completedSteps.some((step) => step !== 'dealer'),
    );

    useEffect(() => {
        if (autoDealer && !hasSelectedDealer) {
            dispatch(setSelectedDealer(autoDealer));
        }
    }, [dispatch, autoDealer, hasSelectedDealer]);

    useEffect(() => {
        if (autoDealer && currentStep === 'dealer') {
            const target = hasProgress ? stepAfterSkippedDealer(defer) : DEALER_AUTO_SELECTED_ORDER[0];
            dispatch(setCurrentStep(target));
        }
    }, [dispatch, autoDealer, currentStep, hasProgress, defer]);
};
